(() => {
  const fonts = {
    georgia: 'Georgia, "Times New Roman", serif',
    times: '"Times New Roman", Times, serif',
    arial: 'Arial, Helvetica, sans-serif',
    verdana: 'Verdana, Geneva, sans-serif',
    courier: '"Courier New", Courier, monospace'
  };

  function init(root){
    if (root.dataset.fontPickerReady === '1') return;

    const panel = root.querySelector('.dc-letter__result-panel');
    const paper = root.querySelector('.dc-letter__paper');
    const preview = root.querySelector('.dc-letter__preview');
    if (!panel || !paper || !preview) return;

    root.dataset.fontPickerReady = '1';

    const wrap = document.createElement('label');
    wrap.className = 'dc-letter__font-picker';
    wrap.innerHTML = `
      <span>Style du courrier</span>
      <select class="dc-letter__font-select" aria-label="Choisir la police du courrier">
        <option value="georgia">Georgia</option>
        <option value="times">Times New Roman</option>
        <option value="arial">Arial</option>
        <option value="verdana">Verdana</option>
        <option value="courier">Courier New</option>
      </select>`;
    panel.insertBefore(wrap, paper);

    const select = wrap.querySelector('select');

    let saved = 'georgia';
    try {
      const v = localStorage.getItem('drcash-letter-font');
      if (v && fonts[v]) saved = v;
    } catch (_) {}

    const apply = key => {
      const family = fonts[key] || fonts.georgia;
      preview.style.fontFamily = family;
      root.style.setProperty('--dc-letter-font', family);
    };

    select.value = saved;
    apply(saved);

    select.addEventListener('change', () => {
      apply(select.value);
      try {
        localStorage.setItem('drcash-letter-font', select.value);
      } catch (_) {}
    });
  }

  const boot = () => document.querySelectorAll('.dc-letter').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once:true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
